import { render, staticRenderFns } from "./SendConfirm.vue?vue&type=template&id=16f258c4&scoped=true"
import script from "./SendConfirm.vue?vue&type=script&lang=js"
export * from "./SendConfirm.vue?vue&type=script&lang=js"
import style0 from "./SendConfirm.vue?vue&type=style&index=0&id=16f258c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f258c4",
  null
  
)

export default component.exports